import _implicitStylesheets from "./footerContainer.css";
import _implicitScopedStylesheets from "./footerContainer.scoped.css?scoped=true";
import _appxFooter from "appx/footer";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "footer": true
  },
  key: 0
};
const stc1 = {
  key: 1
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element} = $api;
  return [api_element("div", stc0, [api_custom_element("appx-footer", _appxFooter, stc1)])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-70rnqe72p2h";
tmpl.legacyStylesheetToken = "page-footerContainer_footerContainer";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
